import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useSetState } from '@domain-group/react-hooks'

import useOrderLeadTime, { useOrderLeadTimeForm } from '@hooks/useOrderLeadTime'

const setServiceId = (value, setState, setEntityState) => {
  const id = Number(value)

  setState({ serviceId: id })
  setEntityState({ orderable_id: id, orderable_type: 'Service' })
}

const hideProductSelector = (serviceId, setState, setEntityState) => {
  setState({ showProductSelect: false })
  setEntityState({ orderable_id: serviceId, orderable_type: 'Service' })
}

const setupState = (initOrderLeadTime, serviceProducts, setState) => {
  const { orderable_id, orderable_type } = initOrderLeadTime || {}

  if (orderable_type === 'ServiceProduct'){
    const product = serviceProducts[orderable_id] || {}
    setState({ serviceId: product.service_id, showProductSelect: true })
    return
  }

  setState({ serviceId: initOrderLeadTime.orderable_id })
}

const defaultState = {
  serviceId: undefined,
  showProductSelect: false,
}

const useCreateOrEditOrderLeadTimeModal = (initOrderLeadTime = {}) => {
  const [state, setState] = useSetState(defaultState)
  const { serviceId, showProductSelect } = state

  const serviceProducts = useSelector(reduxState => reduxState.entities.serviceProducts)

  const {
    callbacks,
    creating,
    deleting,
    orderLeadTime,
    updating,
  } = useOrderLeadTime(initOrderLeadTime)

  const formPayload = useOrderLeadTimeForm(orderLeadTime)

  const { setEntityState } = formPayload

  useEffect(() => setupState(initOrderLeadTime, serviceProducts, setState), [])

  return (
    {
      callbacks: {
        ...callbacks,
        hideProductSelector: () => hideProductSelector(serviceId, setState, setEntityState),
        showProductSelector: () => setState({ showProductSelect: true }),
        setServiceId: value => setServiceId(value, setState, setEntityState),
      },
      creating,
      deleting,
      formPayload,
      serviceId,
      showProductSelect,
      updating,
    }
  )
}

export default useCreateOrEditOrderLeadTimeModal
